import React from 'react';
import {
  Create,
  SimpleForm,
  required,
  ReferenceInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

const redirectToReglaEditGrupoValidacionesTab = (basePath, id, data) => `/grupo-validaciones/${data.idGrupoValidaciones}/1`;

const PrestacionGrupoValidacionesCreate = (props) => (
  <Create {...props}>
    <SimpleForm redirect={redirectToReglaEditGrupoValidacionesTab}>
      <ReferenceInput
        source="idGrupoValidaciones"
        reference="grupo-validaciones"
        label="Grupo Validaciones"
        validate={[required()]}
      >
        <SelectInput optionText="descripcion" optionValue="id" options={{ disabled: true }}/>
      </ReferenceInput>
      <ReferenceInput
        source="idPrestacion"
        reference="prestaciones"
        label="resources.prestacion-grupo-validaciones.fields.prestacion"
        validate={[required()]}
        perPage={100}
        filterToQuery={(searchText) => ({
          descripcion: searchText ? searchText : "",
        })}
      >
        <AutocompleteInput optionText="descripcion" optionValue="id" />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);

export default PrestacionGrupoValidacionesCreate;
